import { Row ,Container, Col, Collapse } from "react-bootstrap";
import classes from "./Packages.module.scss"
import DoneAllIcon from '@mui/icons-material/DoneAll';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import RemoveIcon from '@mui/icons-material/Remove';
import { ClientTypes, CustomerRelations, OrgIdContext } from "../../../store/orgId_context";
import Package from "./Package";
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PeopleIcon from '@mui/icons-material/People';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import { useContext, useEffect, useState } from "react";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import Button from "../../UI/Button";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';


const PackageFull = ({packageData, packageType, type, active, onOrder, reload, amount, payType, paymentType}) =>{
    const { sessionInfo } = useContext(OrgIdContext);
    const [opened, setOpened] = useState();
    const [_paymentType, setPaymentType] = useState("Invoice");
    const [_payType, setPayType] = useState("Monthly");
    const [isActive, setIsActive] = useState();
    const onActvateClick = () => {}
    const onMainClick = (e) =>{
        //e.preventDefault();
        setOpened(prev => !prev)
    }

    useEffect(() =>{
        let currPackage = null;
        if(type === "IEI"){
            currPackage = sessionInfo?.Extended?.CurrentPackages?.IEI_Package;
        }else if(type === "REI"){
            currPackage = sessionInfo?.Extended?.CurrentPackages?.REI_Package;
        }else if(type === "FISC"){
            currPackage = sessionInfo?.Extended?.CurrentPackages?.FISC_Package;
        }
        
        if(currPackage?.PackageCode === packageData?.PackageCode && currPackage?.PayType === payType)
            setIsActive(true);
        else
            setIsActive(false);
    }, [reload, sessionInfo,packageData, payType])

    const onPaymentTypeChange = (e) => {
        setPaymentType(e.target.value);
    }

    const onPayTypeChange = (e) =>{
        setPayType(e.target.value);
    }

    const onOrderClick = (e) => {
        if(onOrder)
            onOrder(packageData, type, paymentType, payType)
    }

    return(
        <Package packageTitle={packageData.PackageName} 
            icon={<DoNotDisturbIcon/>} 
            packageKey={packageData.PackageCode} 
            active={isActive} 
            price={payType === "Monthly" ? packageData.PricePerMonth : packageData.PricePerYear}
            saved={payType === "Monthly" ? null : packageData.PricePerMonth*2}
            /* pricePerYear={packageData.PricePerYear} */
            packageMainTitle={packageData.PackageCode}
            packageType={packageType}
            /* onClick = {onMainClick} */
            onActivateClick={onActvateClick}>
                <ul className={classes["pricing-table-ul"]} style={{marginTop:"3rem"}} >
                    {packageData.QuantityPerMonth && <li style={isActive ? {color:"white"} : {}}><JoinFullIcon className={classes["fa"]}/>Quantity per month: {packageData.QuantityPerMonthVS || packageData.QuantityPerMonth}	</li>}
                    {/* <li><JoinFullIcon className={classes["fa"]}/>Legal compliant e-invoice generation	</li>
                    <li><JoinFullIcon className={classes["fa"]}/>Legal compliant corrective document creation (with one referential document)</li>
                    <li><JoinFullIcon className={classes["fa"]}/>Automatic PDF visualization creation</li>
                    <li><JoinFullIcon className={classes["fa"]}/>Automatically sent to Tax Authority (if requested)</li>
                    <li><JoinFullIcon className={classes["fa"]}/>A-invoice & PDF optionally sent to the buyer (all meaningful e-paths, including Peppol)</li>
                    <li><JoinFullIcon className={classes["fa"]}/>All sendings proof data returned to sender</li>
                    <li><JoinFullIcon className={classes["fa"]}/>E-invoice & PDF optionally returned to sender	</li>
                    <li><JoinFullIcon className={classes["fa"]}/><u>No document archiving</u>, no data archiving   (data & documents deleted after 48 hours)	</li>
                    <li><JoinFullIcon className={classes["fa"]}/><u>No later tax reports</u></li> */}
                </ul>
                {isActive && <>
                    <div style={{textAlign:"center", marginTop:"1rem"}}>
                        <CheckCircleIcon style={{fontSize:"2rem", color: "white"}}/>
                    </div>
                    <div style={{textAlign:"center"}}>Active</div>
                </>}
                {!isActive && <>
                    <div style={{textAlign:"center", marginTop:"1rem"}}><Button className="ps-2 pe-2" onClick={onOrderClick}><ShoppingCartCheckoutIcon style={{marginRight:"1rem"}}/>Order</Button></div>
                    {/* <div className={`d-flex ${classes["select-btn"]}`} onClick={onMainClick}>
                        <div>{opened ? <KeyboardDoubleArrowDownIcon/> : <KeyboardDoubleArrowRightIcon/>}</div>
                        <div style={{textAlign:"center", width:"100%"}}>Select</div>
                    </div>
                    
                    <Collapse in={opened}>
                        <div style={{marginTop:"1rem"}}>
                            <FormControl fullWidth>
                                <InputLabel id={"payment-type"+packageData.PackageName}>Payment type</InputLabel>
                                <Select
                                    labelId={"payment-type"+packageData.PackageName}
                                    id={"payment-type-select"+packageData.PackageName}
                                    value={paymentType}
                                    label="Payment type"
                                    onChange={onPaymentTypeChange}
                                >
                                    <MenuItem value={"Invoice"}><ReceiptIcon/>Invoice</MenuItem>
                                    <MenuItem value={"PayPal/BankCard"}><CreditCardIcon/>Paypal/Bank card</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginTop:"1rem"}}>
                                <InputLabel id={"pay-type"+packageData.PackageName}>Type</InputLabel>
                                <Select
                                    labelId={"pay-type"+packageData.PackageName}
                                    id={"pay-type-select"+packageData.PackageName}
                                    style={{color:"white"}}
                                    value={payType}
                                    label="Pay tyle"
                                    onChange={onPayTypeChange}
                                >
                                    <MenuItem value={"Monthly"}><TodayIcon/>Monthly</MenuItem>
                                    <MenuItem value={"Yearly"}><CalendarMonthIcon/>Yearly</MenuItem>
                                </Select>
                            </FormControl>
                        <div style={{textAlign:"center", marginTop:"1rem"}}><Button onClick={onOrderClick}>Order</Button></div>
                        </div>
                    </Collapse> */}
                </>}
            </Package>
    )
}

export default PackageFull;